import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import MeasureTable, { MEASURE_LIST_COLUMNS, StandardMeasureColumn } from 'app/components/table/MeasureTable';
import KeyUtils from 'app/common/util/KeyUtils';
import { SINGLE_SELECTION, SingleSelection, SortMode } from 'app/common/table/ManagedTable';
import { DetailedSolution } from 'app/model/SOL49';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { MeasureDto } from 'app/model/CORE';
import memoizeOne from 'memoize-one';
import './SolutionMeasures.less';

interface SolutionMeasuresProps {
    solution: DetailedSolution;
    selectedMeasure: MeasureDto;
    onSelectedMeasureChange: (measure: MeasureDto) => void;
    onRemoveMeasure?: (measure: MeasureDto, solution: DetailedSolution) => void;
}

export class SolutionMeasures extends PureComponent<SolutionMeasuresProps> {
    selection = memoizeOne(
        (selectedMeasure: MeasureDto): SingleSelection<MeasureDto> => ({
            selectionMode: SINGLE_SELECTION,
            onSelectionChange: this.props.onSelectedMeasureChange,
            selectedItem: selectedMeasure,
        }),
    );

    render() {
        const nbRegulations =
            this.props.solution?.measures?.filter(measure => MeasureUtils.isRegulationOrMcdmOnly(measure)).length || 0;
        const nbReroutings =
            this.props.solution?.measures?.filter(measure => MeasureUtils.isRerouting(measure)).length || 0;

        const columns = MEASURE_LIST_COLUMNS.slice();
        // Only show delete icon if solution contain more than 1 measure
        if (this.props.solution.measures.length > 1 && this.props.onRemoveMeasure) {
            columns.push(StandardMeasureColumn.REMOVE);
        }

        return (
            <Flex direction="vertical" grow={false} className="solution-measures">
                <Flex className="title">MEASURES TO APPLY</Flex>
                <Flex>
                    <Flex grow={false} className="summary-container">
                        <Flex direction="vertical" size="6em" className="summary">
                            <Flex className="number">{nbRegulations}</Flex>
                            <Flex className="type">Regulations</Flex>
                        </Flex>
                        <Flex direction="vertical" size="6em" className="summary">
                            <Flex className="number">{nbReroutings}</Flex>
                            <Flex className="type">Reroutings</Flex>
                        </Flex>
                    </Flex>
                    <Flex className="overflow table">
                        <MeasureTable
                            onRemoveMeasure={measure => this.props.onRemoveMeasure(measure, this.props.solution)}
                            data={this.props.solution.measures}
                            columns={columns}
                            keyProvider={KeyUtils.MEASURE_KEY_PROVIDER}
                            columnResizeDisabled={true}
                            noDataMessage={'No measures'}
                            sortMode={SortMode.NONE}
                            selection={this.selection(this.props.selectedMeasure)}
                        />
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}
